import { c as _c } from "react/compiler-runtime";
import type { Address } from '@morpho-org/blue-sdk';
import { isDefined } from '@morpho-org/morpho-ts';
import { memo } from 'react';
import { useWeb3Context } from '@/contexts/Web3Context';
import AddressWithCopyAndExplorer from '../../components/AddressWithCopyAndExplorer';
import { getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
import VaultPendingTimelockHeader from './VaultV2PendingTimelockHeader';
interface VaultV2PendingTimelockAddressProps {
  currentValue?: Address;
  newValue: Address;
  functionName: string;
}
const VaultV2PendingTimelockAddress = t0 => {
  const $ = _c(20);
  const {
    currentValue,
    newValue,
    functionName
  } = t0;
  let t1;
  if ($[0] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName
    });
    $[0] = functionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    label,
    criticality
  } = t1;
  const {
    targetChainId
  } = useWeb3Context();
  let t2;
  if ($[2] !== criticality || $[3] !== label) {
    t2 = <VaultPendingTimelockHeader title={label} criticality={criticality} />;
    $[2] = criticality;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currentValue || $[6] !== targetChainId) {
    t3 = isDefined(currentValue) && <StyledVaultPendingTimelock.Row><span className="text-2xs text-foreground">Current address</span><AddressWithCopyAndExplorer address={currentValue} chainId={targetChainId} /></StyledVaultPendingTimelock.Row>;
    $[5] = currentValue;
    $[6] = targetChainId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = isDefined(currentValue) ? "New address" : "Address";
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-2xs text-foreground">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== newValue || $[11] !== targetChainId) {
    t6 = <AddressWithCopyAndExplorer address={newValue} chainId={targetChainId} />;
    $[10] = newValue;
    $[11] = targetChainId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <StyledVaultPendingTimelock.Row>{t5}{t6}</StyledVaultPendingTimelock.Row>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t7) {
    t8 = <div className="flex flex-col">{t2}{t3}{t7}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export default memo(VaultV2PendingTimelockAddress);